import { Box, Grid, MenuItem, Typography } from "@mui/material";
import React, { memo, useContext } from "react";
import { AppContext } from "../../../lib/Context";
import TextInput from "../../../components/textInput";
import { handleOpenSnackBar } from "../../../utils/helper";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import { useLocation } from "react-router-dom";

const PaperBillingCharges = () => {
  const {
    paperBillingPrice,
    setPaperBillingPrice,
    contractLength,
    generalInfo,
    setGeneralInfo,
  } = useContext(AppContext);
  const location = useLocation();

  const isDetailPage = location.pathname === "/prospect-details";

  const handleUpdateCharges = (event) => {
    const selectedLength = contractLength.find(
      (item) => item.isSelected === true
    )?.value;

    if (selectedLength === undefined) {
      handleOpenSnackBar("error", "Kindly select contract length");
      return;
    }

    const numericValue = parseFloat(event.target.value);
    let selected = { ...paperBillingPrice };

    // Length-based price validation
    const lengthValidation = {
      12: selected.length12,
      18: selected.length18,
      24: selected.length24,
      36: selected.length36,
    };

    // Reset error state
    selected.error = false;
    selected.errorMessage = "";

    if (numericValue < 0) {
      selected.error = true;
      selected.errorMessage = "Value cannot be less than 0";
    } else if (numericValue > selected.highPrice) {
      selected.error = true;
      selected.errorMessage = `Sale price cannot be greater than ${selected.highPrice}`;
    } else if (numericValue < lengthValidation[selectedLength]) {
      selected.salePrice = numericValue;
      selected.error = true;
      selected.errorMessage = `For Contract length ${selectedLength}, sale price cannot be less than ${lengthValidation[selectedLength]}`;
    } else {
      selected.salePrice = numericValue;
    }

    setPaperBillingPrice(selected);
  };

  const handleChangeValue = (event) => {
    const { name, value } = event.target;

    setGeneralInfo({ ...generalInfo, [name]: value });
  };

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Billing
      </Typography>
      <Grid container mt={0} spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"E-Billing"} htmlFor={"e-billing"} />
          <CustomDropDown
            id={"e-billing"}
            variant={"filled"}
            value={generalInfo.eBilling}
            name={"eBilling"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          >
            {["Yes", "No"].map((val, ind) => (
              <MenuItem key={ind} value={val}>
                {val}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>

        {generalInfo.eBilling === "No" && (
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"E-billing charges"} />
            <TextInput
              id={"paper-billing-charges"}
              required
              type={"number"}
              variant={"filled"}
              value={paperBillingPrice.salePrice}
              // onChange={handleUpdateCharges}
              error={paperBillingPrice.error}
              helperText={paperBillingPrice.errorMessage}
              onWheel={(e) => e.target.blur()}
              readonly={true}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default memo(PaperBillingCharges);
